import React from 'react';

export const MobilePhone = ({shareUrl, outputUrl}) => {
  return (!shareUrl || !outputUrl) ? null :
    <div className={"container--mobile-phone"}>
      {/*Start Copy and Paste from Previous Site*/}
      <div className="soccer-mobile">
        <div id="soccer-app" className="singular-app">
          <iframe
            width="100%"
            height="100%"
            name="htmlComp-iframe"
            scrolling="auto"
            src={shareUrl}
            title={"iframe-mobile-phone"}
          />
        </div>
        <div id="background" className="background-image">
          <img src={"./images/samsung-phone.png"} alt={"mobile phone"} />
        </div>
      </div>
      {/*End Copy and Paste from Previous Site*/}
      <div className={"wrapper--video-and-overlay"}>
        <div>
          <video
            autoPlay
            loop={true}
            id="vid"
            muted
          >
            <source
              src="https://singular-live.s3-us-west-2.amazonaws.com/Football.mp4"
              type="video/mp4"
            />
          </video>
        </div>
        <div className={"overlay"}>
          <iframe
            src={outputUrl}
            title={"iframe--overlay"}
          />
        </div>
      </div>
    </div>
};

export default MobilePhone;